module.exports = __webpack_public_path__ + "img/AltoGlobal.efc48119.png";